import { gql } from '@apollo/client';
import { REPORTING_PERIOD_ITEM, REPORTING_REPORTER_ITEM } from '../fragments/reportingRequirement';

export const REPORTING_REQUIREMENT_LIST = gql`
  query reportingRequirementList($filter: ReportingRequirementFilter) {
    requirements: reportingRequirementList(filter: $filter) {
      id
      name
      status
      itemType
      itemId
      itemName
      associationType
      associationId
      associationName
      frequency
      frequencyLabel
      startDate
      endDate
      fixedDueDate
      dueOffsetDays
      openOffsetDays
      nextDueOn
      updatedAt
      statusCounts {
        status
        label
        count
      }
      reporters {
        ...reportingReporterItem
        periods {
          ...reportingPeriodItem
        }
      }
    }
  }
  ${REPORTING_REPORTER_ITEM}
  ${REPORTING_PERIOD_ITEM}
`;
